/**
 * HomeHero functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class HomeHero {
  /**
   * Constructs a new HomeHero instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.heroNavigation = this.element.querySelector('[data-component="hero-navigation"]')
    this.heroNavigationItems = this.heroNavigation.queryAll('li')
    this.videoColumn = this.element.querySelector('.column.video')

    const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

    this.videoColumn.addEventListener('transitionend', () => {
      document.body.classList.add('home-loaded')
    })

    if (touchDevice) {
      document.body.classList.add('home-loaded')
    }

    this.heroNavigationList = this.element.querySelector('[data-component="hero-navigation-list"]')
    this.heroNavigationListItems = this.heroNavigationList.queryAll('ul li')

    this.heroNavigationItems.forEach((item) => {
      item.addEventListener('mouseenter', (e) => {
        const index = this.heroNavigationItems.indexOf(item)
        this.activate(item, index)
      })
    })

    this.heroNavigationItems.forEach((item) => {
      item.addEventListener('mouseleave', (e) => {
        this.reset()
      })
    })

  }

  reset () {
    this.heroNavigationListItems.forEach((item) => {
      item.classList.remove('active')
    })
  }

  activate (item, index) {
    this.heroNavigationListItems[index].classList.add('active')
  }

}



// WEBPACK FOOTER //
// ./components/section/home-hero/index.js